import es from './locales/es.json'
import en from './locales/en.json'

export default {
  es,
  en,
}
